(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everlinx-video-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initClip(clip) {
    if (clip.dataset.evxReady === 'true') return;
    clip.dataset.evxReady = 'true';
    var btn = clip.querySelector('[data-evx-play]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (clip.classList.contains('is-playing')) return;
      var stage = clip.querySelector('[data-evx-stage]');
      if (!stage) return;
      var provider = clip.getAttribute('data-provider');
      var node = null;
      if (provider === 'shopify') {
        var tpl = clip.querySelector('template[data-evx-video]');
        if (tpl) node = tpl.content.cloneNode(true);
      } else if (provider === 'youtube' || provider === 'vimeo') {
        var id = clip.getAttribute('data-video-id');
        if (id) {
          var src = provider === 'vimeo'
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0'
            : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
          var iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
          iframe.setAttribute('allowfullscreen', '');
          iframe.loading = 'lazy';
          iframe.className = 'everlinx-vid__media';
          node = iframe;
        }
      }
      if (node) {
        stage.appendChild(node);
        clip.classList.add('is-playing');
      }
    });
  }
  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-section-type="everlinx-video-wall"] [data-evx-clip]').forEach(initClip);
  }
  if (document.readyState !== 'loading') {
    boot(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
